<template>
  <div>
    <el-form ref="form" label-width="50px" label-position="left" :model="form" :rules="rules">
      <el-row class="nuv-wrap" v-for="(item, index) in value" :key="index">
        <el-col class="col1">
          <el-form-item label="曝光">
            <el-select
              v-model="item.uvMatch"
              placeholder="请选择"
              :disabled="disabled"
              @change="$emit('change', value)"
            >
              <el-option
                v-for="(opt, optIndex) in selOptions"
                :key="optIndex"
                :value="opt.value"
                :label="opt.label"
              >{{ opt.label }}</el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col class="col2">
          <template v-if="item.uvMatch === 0">
            <el-form-item
              label=""
              label-width="10px"
              :prop="'value.' + index + '.frequency'"
              :rules="rules.frequency"
            >
              <el-input v-model="item.frequency" @change="$emit('change', value)"></el-input>
            </el-form-item>
          </template>
          <template v-else>
            <el-row>
              <el-col class="min-item">
                <el-form-item
                  label=""
                  label-width="10px"
                  :prop="'value.' + index + '.minFrequency'"
                  :rules="rules.minFrequency"
                >
                  <el-input v-model="item.minFrequency" placeholder="最小值" @change="$emit('change', value)"></el-input>
                </el-form-item>
              </el-col>
              <el-col class="rangeItem">~</el-col>
              <el-col class="max-item">
                <el-form-item
                  label=""
                  label-width="0px"
                  :prop="'value.' + index + '.maxFrequency'"
                  :rules="rules.maxFrequency"
                >
                  <el-input v-model="item.maxFrequency" placeholder="最大值" @change="$emit('change', value)"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </template>
        </el-col>
        <el-col class="col3"><el-form-item label="" label-width="10px">次设备占比</el-form-item></el-col>
        <el-col class="col4">
          <el-form-item
            label=""
            label-width="1px"
            :prop="'value.' + index + '.uvPercentage'"
            :rules="rules.uvPercentage"
          >
            <el-input
              v-model="item.uvPercentage"
              style="width: 80%"
              maxlength="6"
              @change="$emit('change', value)"
            ></el-input>
            %
          </el-form-item>
        </el-col>
        <el-col class="col5">
          <i
            @click="addHandle"
            class="selIcon el-icon-circle-plus-outline"
          ></i>
          <i
            v-if="value && value.length > 1"
            @click="removeHandle(index)"
            class="selIcon el-icon-remove-outline"
          ></i>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
export default {
  components: {
  },
  props: {
    scheduleForm: { type: Object, default: () => {} },
    value: {
      type: Array,
      default: []
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    let checkUvTarget = (rule, value, callback) => {
      const fields = rule.field.split('.')
      const item = this.value[fields[1]]
      const errorMsg = this.checkUvTargetValue(item, fields[2], value)
      if (errorMsg) {
        return callback(new Error(errorMsg))
      }
      callback()
    }
    let checkUvPercentage = (rule, value, callback) => {
      const fields = rule.field.split('.')
      const item = this.value[fields[1]]
      const errorMsg = this.checkUvPercentageValue(item, fields[2], value)
      if (errorMsg) {
        return callback(new Error(errorMsg))
      }
      callback()
    }
    let checkRangeValue = (rule, value, callback) => {
      const fields = rule.field.split('.')
      const item = this.value[fields[1]]
      const errorMsg = this.checkMinMaxValue(item, fields[2], value)
      if (errorMsg) {
        return callback(new Error(errorMsg))
      }
      callback()
    }
    return {
      form: {
        value: []
      },
      selOptions: [
        {
          label: '等于',
          value: 0
        }, {
          label: '区间',
          value: 1
        }
      ],
      rules: {
        frequency: [{ validator: checkUvTarget, trigger: 'blur' }],
        uvPercentage: [{ validator: checkUvPercentage, trigger: 'blur' }],
        minFrequency: [{ validator: checkRangeValue, trigger: 'blur' }],
        maxFrequency: [{ validator: checkRangeValue, trigger: 'blur' }]
      }
    }
  },
  created() {
  },
  watch: {
    value: {
      handler(newValue, oldValue) {
        this.form.value = this.value || []
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    handleCheck(obj, val) {
      const type = obj.componentReg.validationType
      const allowingList = obj.componentReg.allowing
      const message = obj.componentReg.help
      const required = obj.componentReg.optional === false || obj.componentReg.need === true
      const maxLength = obj.componentReg.maxLength
      const minLength = obj.componentReg.minLength
      const max = obj.componentReg.maxRange
      const min = obj.componentReg.minRange
      let status = { code: 0, message: '成功' }
      if (required && !val) {
        status = { code: -1, message: '必填' }
        return status
      }
      if (obj.componentReg.validator_length || obj.componentReg.validateLength) {
        if (val) {
          if (!(val.length >= minLength && val.length <= maxLength)) {
            status = { code: -1, message: message }
            return status
          }
        }
      }
      // 类型校验
      // 数字 number
      if (type && type.indexOf('number') > -1) {
        if (val) {
          if (isNaN(val)) {
            status = { code: -1, message: message }
            return status
          }
          // 只有数字类型会校验大小
          if (!(parseFloat(val) >= min && parseFloat(val) <= max)) {
            status = { code: -1, message: message }
            return status
          }
        }
      }
      let newValue = val
      if (allowingList) {
        // eslint-disable-next-line
        const charList = allowingList.replace('.', '\\\.')
        const reg = new RegExp('[' + charList + ']', 'g')
        newValue = val.replace(reg, '')
      }
      // 数字+字母 alphanumeric
      if (type && type.indexOf('alphanumeric') > -1) {
        if (newValue) {
          if (!/^[A-Za-z0-9]+$/.test(newValue)) {
            status = { code: -1, message: message }
            return status
          }
        }
      }
      // 数字中文和字母 letternumeric
      if (type && type.indexOf('letternumeric') > -1) {
        if (newValue) {
          if (!/^[A-Za-z0-9\u4e00-\u9fa5]+$/.test(newValue)) {
            status = { code: -1, message: message }
            return status
          }
        }
      }
      // 自定义 custom
      if (type && type.indexOf('custom') > -1) {
        const regexp = obj.componentReg.regexp || ''
        const regx = new RegExp(regexp)
        if (val) {
          if (!regx.test(val)) {
            status = { code: -1, message: message }
            return status
          }
        }
      }
      // 日期 date
      if (type && type.indexOf('date') > -1) {
        if (val) {
          const format = obj.componentReg.format || 'yyyy-mm-dd'
          if (!this.parseDate(val, format)) {
            status = { code: -1, message: message }
            return status
          }
        }
      }
      // 邮件 email
      if (type && type.indexOf('email') > -1) {
        if (val) {
          if (
            !/^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/.test(
              val
            )
          ) {
            status = { code: -1, message: message }
            return status
          }
        }
      }
      // 网址
      if (type && type.indexOf('url') > -1) {
        if (val) {
          const strRegex =
            '^((https|http|ftp)://)?' + // (https或http或ftp):// 可有可无
            "(([\\w_!~*'()\\.&=+$%-]+: )?[\\w_!~*'()\\.&=+$%-]+@)?" + // ftp的user@  可有可无
            '(([0-9]{1,3}\\.){3}[0-9]{1,3}' + // IP形式的URL- 3位数字.3位数字.3位数字.3位数字
            '|' + // 允许IP和DOMAIN（域名）
            '(localhost)|' + // 匹配localhost
            "([\\w_!~*'()-]+\\.)*" + // 域名- 至少一个[英文或数字_!~*\'()-]加上.
            '\\w+\\.' + // 一级域名 -英文或数字  加上.
            '[a-zA-Z]{1,6})' + // 顶级域名- 1-6位英文
            '(:[0-9]{1,5})?' + // 端口- :80 ,1-5位数字
            '((/?)|' + // url无参数结尾 - 斜杆或这没有
            "(/[\\w_!~*'()\\.;?:@&=+$,%#-]+)+/?)$" // 请求参数结尾- 英文或数字和[]内的各种字符
          const urlFilter = new RegExp(strRegex, 'i') // i不区分大小写
          if (!urlFilter.test(val)) {
            status = { code: -1, message: message }
            return status
          }
        }
      }
      return status
    },
    checkUvPercentageValue(item, field, value) {
      if (value !== 0 && !value) {
        return '请输入数字'
      }
      if (value === 0 || value === '0') {
        return '请输入大于0的数字'
      }
      if (isNaN(value)) {
        return '请输入数字'
      }
      if (value > 100) {
        return '不能大于100'
      }
      let regex = /^\d+(\.\d{0,2})?$/;
      if (!regex.test(value)) {
        return '不能超过2位小数'
      }
      return ''
    },
    checkUvTargetValue(item, field, value) {
      let pattern = /^[0-9]*[1-9][0-9]*$/; // 定义正则表达式
      if ((value !== 0 && !value) || !pattern.test(value)) {
        return '请输入正整数'
      }
      if (this.scheduleForm && this.scheduleForm.frequency !== 1 && this.scheduleForm.trafficDaily && value > this.scheduleForm.trafficDaily) {
        return '最大值为' + this.scheduleForm.trafficDaily
      }
      return ''
    },
    checkMinMaxValue(item, field, value) {
      let pattern = /^[0-9]*[1-9][0-9]*$/; // 定义正则表达式
      if ((value !== 0 && !value) || !pattern.test(value)) {
        return '请输入正整数'
      }
      if (this.scheduleForm && this.scheduleForm.frequency !== 1 && this.scheduleForm.trafficDaily && parseFloat(value) > this.scheduleForm.trafficDaily) {
        return '不能大于' + this.scheduleForm.trafficDaily
      }
      if (field === 'maxFrequency' && item.minFrequency && parseFloat(value) <= parseFloat(item.minFrequency)) {
        return '不能小于最小值'
      }
      return ''
    },
    addHandle() {
      this.value.push({
        uvMatch: 0,
        frequency: '',
        uvPercentage: '',
        minFrequency: '',
        maxFrequency: ''
      })
    },
    removeHandle(index) {
      this.value.splice(index, 1)
    }
  }
}
</script>

<style lang="stylus" scoped>
  .selIcon {
    cursor pointer
    margin-right 10px
    font-size 20px
    color #ff8b00
  }
  .nuv-wrap {
    min-width 570px
    margin-bottom 20px
    &:nth-last-child(1){
      margin-bottom 0
    }
    .col1 {
      min-width 126px!important
      width 17%!important
    }
    .col2 {
      min-width 165px!important
      width 24%!important
    }
    .col3 {
      width 88px!important
    }
    .col4 {
      width 18%!important
      max-width 184px!important
    }
    .col5 {
      min-width 60px!important
      width 8%!important
    }
    .min-item {
      width: 50%!important;
    }
    .max-item {
      width: 44%!important;
    }
    .rangeItem {
      width: 6%!important;
      text-align: center
    }
  }
</style>
